import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component} from "@angular/core";
import {MemberEntityModel} from "../member-entity.model";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {MemberData} from "../member.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-member-edit-page",
    templateUrl: "./member-edit-page.component.html",
    providers: [(provideEntityModel(MemberEntityModel))]
})
export class MemberEditPageComponent extends AbstractEditPage {
    constructor(public model: MemberEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    addingAnother(previousEntity: MemberData): void {
        this.model.data.membershipType.membershipTypeId = previousEntity.membershipType.membershipTypeId;
    }
}
